import { Injectable, EventEmitter, ComponentRef } from '@angular/core';
import { DynamicComponent } from "./dynamic.component";
import { DynamicEmptyComponent } from './dynamic.empty.component';

@Injectable()
export class DynamicComponentService {
    /**
     * Массив вставленных компонентов
     */
    private components:ComponentRef<any>[] = [];

    private static _DCinstance:DynamicComponent;
    /**
     * Экземпляр компоненты DynamicComponent. Этот компонент сам вызывает данный сервис и кладет сюда this 
     */
    static get DCinstance(){
        return DynamicComponentService._DCinstance;
    }
    static set DCinstance(instance:DynamicComponent){
        if(instance instanceof DynamicComponent){
            DynamicComponentService._DCinstance = instance;
        }
    }
    /**
     * Список HTML элементов, которым надо передать фокус при закрытии всплывающего окна.
     */
    private _focusElements:HTMLElement[] = [];
    constructor() { }
    /**
     * Вставляет динамический компонент.
     * @param component Вставляемый класс комопненты.
     * @returns Экземпляр вставляемого классса.
     */
    attach<T extends DCInput> (component:{ new(...args : any[]):T }) {
        this._focusElements.push(<HTMLElement>document.activeElement);
        let componentRef = DynamicComponentService._DCinstance.insertComponent(component);
        this.components.push(componentRef);
        componentRef.instance.destroyEmitter.subscribe(()=>{
            // Сбрасываем переменные для передвижения стрелками по элементам страницы.
            // (<any>window).spatialNavigationReset ? (<any>window).spatialNavigationReset() : null;
            this.components.splice(this.components.indexOf(componentRef), 1);
            componentRef.destroy();
            if(this._focusElements.length){
                const element = this._focusElements.pop();
                if(element && "focus" in element){
                    setTimeout(() => {
                        element.focus();
                    }, 200);
                }
            } else {
                document.body.focus();
            }
        });
        return componentRef.instance ;
    }
    /**
     * Динамически вставляет пустой компонент, в который можно вставить HTML строку.
     * @param Html Строка, которая будет преобразована в дом дерево
     * @returns Экземпляр вставляемого классса.
     */
    attachHtml(Html:string = "Внимание!"){
        const component = this.attach(DynamicEmptyComponent);
        component.content = Html;
        return component;
    }
    /**
     * Уничтожает все вставленные компоненты.
     */
    destroyAll(){
        this.components.map((component)=>{
            component && ("destroy" in component) && component.destroy();
        });
        this.components = [];
    }
}

/**
 * Интерфейс для вставляемого компонента.
 */
export interface DCInput {
    /**
     * Подписчик для удаления компоненты.
     */
    destroyEmitter:EventEmitter<null>;
}